export default {
    sm: "40em", // 640px
    md: "48em", // 768px
    lg: "64em", // 1024px
    xl: "80em" //  1280px
};